import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "icon"]

  connect() {
    this.boundShow = this.showSpinner.bind(this)
    this.boundHide = this.hideSpinner.bind(this)
    this.element.addEventListener('ajax:send', this.boundShow)
    this.element.addEventListener('ajax:complete', this.boundHide)
  }

  disconnect() {
    this.element.removeEventListener('ajax:send', this.boundShow)
    this.element.removeEventListener('ajax:complete', this.boundHide)
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('d-none')
    if (this.hasIconTarget) this.iconTarget.classList.add('d-none')
  }

  hideSpinner() {
    this.spinnerTarget.classList.add('d-none')
    if (this.hasIconTarget) this.iconTarget.classList.remove('d-none')
  }
}
